<template>
  <div class="cheyun_container">
    <div class="cheyun_header">
      <div class="cheyun_logo">
        <img src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/logo_20221226.png" />
      </div>
    </div>
    <div class="cheyun_wrapper">
      <template v-if="status == 1">
        <div class="wrapper_tit">密码设置</div>
        <div class="wrapper_item">
          <div class="item_attr">密码：</div>
          <div class="item_val">
            <el-input
              v-model.trim="pwd1"
              type="password"
              placeholder="请输入密码"
              maxlength=16
              show-password
            />
          </div>
        </div>
        <div class="wrapper_item wrapper_item2">
          <div class="item_attr">确认密码：</div>
          <div class="item_val">
            <el-input
              v-model.trim="pwd2"
              type="password"
              placeholder="请再次输入密码"
              maxlength=16
              show-password
            />
          </div>
        </div>
        <div class="wrapper_item wrapper_item3">
          <div class="item_attr"></div>
          <div class="item_val">
            注：密码为8-40位（英文字母+数字组合&nbsp;+特殊字母）
          </div>
        </div>
        <div class="submit_btn" @click="resetPwdFn">提交</div>
      </template>
      <template v-else>
        <div class="success_tit">
          <div class="success_icon"></div>
          <div class="success_text">恭喜您，密码设置成功!</div>
        </div>
        <router-link 
          class="success_link"
          :to="{
            path:'/login'
          }"
        >
          打开车云智能汽车云评测系统
        </router-link>
      </template>
    </div>
    <div class="cheyun_footer">
      <div class="footer_item">若果您在使用过程中，有任何问题，请拨打电话或者发送邮件：</div>
      <div class="footer_item"><span class="footer_text1">客服电话：</span><span class="footer_text2">13301399328</span></div>
      <div class="footer_item">邮箱：help&#64;diandong.com</div>
      <div class="footer_item">网址：ceping.cheyun.com</div>
    </div>
  </div>
</template>

<script>
import {
  ref
} from "vue";
import {
  useRoute
} from "vue-router";
import {
  ElInput,
  ElMessage
} from "element-plus";
import {
  resetPwd
} from "@/api";
export default {
  components:{
    ElInput
  },
  setup(){
    const route = useRoute();
    let {email,secret_code} = route.query;
    console.log(email,secret_code)
    const pwd1 = ref("");
    const pwd2 = ref("");
    const status = ref(1);
    let loading = false;
    const resetPwdFn = ()=>{
      if(loading){
        return;
      }
      if(!pwd1.value){
        ElMessage.warning("请输入密码！");
        return;
      }
      if(!pwd2.value){
        ElMessage.warning("请再次输入密码！");
        return;
      }
      const reg1 = /^\S*$/;
      if(!reg1.test(pwd1.value)){
        ElMessage.warning("密码不可包含空格！");
        return;
      }
      if(pwd1.value != pwd2.value){
        ElMessage.warning("两次输入不一致！");
        return;
      }
      if(pwd1.value.length<8 || pwd1.value.length>16){
        ElMessage.warning("密码长度为8—16位！");
        return;
      }
      const reg2 = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.+$/g;
      if(!reg2.test(pwd1.value)){
        ElMessage.warning("需包含数字中至少两种字符！");
        return;
      }
      loading = true;
      resetPwd({
        email,
        secret_code,
        pwd:pwd1.value,
        re_pwd:pwd2.value,
      }).then(res=>{
        loading = false;
        if(res && res.code && res.code == 200){
          status.value = 2;
        }else{
          ElMessage.warning(res.message || "重置密码失败，请重试！");  
        }
      }).catch(()=>{
        loading = false;
        ElMessage.warning("重置密码失败，请重试！");
      })
    }

    
    return {
      pwd1,
      pwd2,
      resetPwdFn,
      status
    }
  }
}
</script>

<style lang="less" scoped>
.cheyun_container{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 30px;
  width: 100%;
  height: 100%;
  .cheyun_header{
    width: 100%;
    height: 70px;
    border-bottom: solid 2px #18A8CA;
    display: flex;
    align-items: center;
    padding-left: 30px;
    flex-shrink: 0;
    .cheyun_logo{
      width: 278px;
      height: 29px;
      img{
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .cheyun_wrapper{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 30px;
    padding-bottom: 50px;
    .wrapper_tit{
      font-size: 18px;
      font-weight: 400;
      color: #1F1F1F;
      line-height: 25px;
      letter-spacing: 1px;
      margin:0 auto 37px;
      transform: translateX(20px);
    }
    .wrapper_item{
      width: 440px;
      display: flex;
      align-items: center;
      &.wrapper_item2{
        margin-top: 22px;
      }
      &.wrapper_item3{
        margin-top: 18px;
      }
      .item_attr{
        font-size: 16px;
        font-weight: 400;
        color: #1F1F1F;
        width: 90px;
        padding-right: 10px;
        text-align: right;
      }
      .item_val{
        font-size: 14px;
        font-weight: 400;
        color: #7D7D7D;
        line-height: 20px;
        :deep(.el-input){
          width: 350px;
          height: 48px;
          background: #F4F4F4;
          border-radius: 6px;
        }
        :deep(.el-input .el-input__inner){
          width: 100%;
          height: 100%;
          padding-left: 33px;
          background: transparent;
          border: none;
        }
        :deep(.el-input .el-input__clear){
          height: 100%;
        }
      }
    }
    .submit_btn{
      margin: 30px auto 0;
      width: 170px;
      height: 47px;
      background: #1FBCBF;
      border-radius: 2px;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 47px;
      text-align: center;
      transform: translateX(20px);
    }

     .success_tit{
      display: flex;
      justify-content: center;
      align-items: center;
      .success_icon{
        width: 27px;
        height: 27px;
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/success_20230203.svg) no-repeat center center;
      }
      .success_text{
        margin-left: 14px;
        font-size: 18px;
        font-weight: 400;
        color: #1F1F1F;
        line-height: 25px;
        letter-spacing: 1px;
      }
    }
    .success_link{
      margin-top: 39px;
      font-size: 16px;
      font-weight: 400;
      color: #318DE5;
      line-height: 22px;
      letter-spacing: 1px;
      text-decoration: underline;
      text-align: center;
    }
  }
  .cheyun_footer{
    width: 100%;
    padding: 22px 0;
    background: #F4F4F4;
    flex-shrink: 0;
    .footer_item{
      font-size: 14px;
      font-weight: 400;
      color: #494949;
      text-align: center;
      line-height: 23px;
      .footer_text1{
        color: #000000;
        font-weight: 500;
      }
      .footer_text2{
        color: #318DE5;
      }
    }
  }
}
</style>